import { Col, Row } from "antd";
import CategoryIcon from "../../../../../assets/icons/category-gray.svg";
import helpers from "../../../../../common/helpers/common";
import { TodoTaskItem } from "../../entity/Entity";

type TodoItemProps = {
  item: TodoTaskItem;
  onClickTodo: (item: TodoTaskItem) => void;
};

export default function TodoItem({ item, onClickTodo }: TodoItemProps) {
  return (
    <div onClick={() => onClickTodo(item)} className="td001-todo__item">
      <div className="td001-todo__item--header">
        <img style={{ width: "24px" }} alt="" src={CategoryIcon} />
        <span className="td001-todo__item--name">
          {item.category.description}
        </span>
      </div>
      <Row className="td001-todo__item--content" gutter={[0, 12]}>
        <Col span={24}>
          <Row>
            <Col style={{ fontSize: "14px" }} span={6}>
              案件名
            </Col>
            <Col style={{ fontSize: "14px", textAlign: "justify" }} span={18}>
              {item.project.name}
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row>
            <Col style={{ fontSize: "14px" }} span={6}>
              工事名
            </Col>
            <Col style={{ fontSize: "14px", textAlign: "justify" }} span={18}>
              {item.construction.name}
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row>
            <Col style={{ fontSize: "14px" }} span={6}>
              タスク内容
            </Col>
            <Col
              style={{ textAlign: "justify", whiteSpace: "pre-line" }}
              span={18}
            >
              {item.body}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row
        style={{ flex: 1, paddingRight: "24px", marginTop: "12px" }}
        align="bottom"
      >
        <Col style={{ textAlign: "right", fontSize: "14px" }} span={24}>
          {helpers.convertTime(item.createdAt)}
        </Col>
      </Row>
    </div>
  );
}
